import {
    CARGAR_ESTADISTICAS_PACIENTE,
    CARGAR_ESTADISTICAS_PACIENTE_EXITO,
    CARGAR_ESTADISTICAS_PACIENTE_ERROR,
    CERRAR_SESION
} from '../types';


/*
====================================
ESTADO INICIAL
====================================

Este reducer concentra la información
de Estadísticas y Cobros.

Guarda:

- período consultado;
- asistencia;
- economía;
- resumen por paciente;
- turnos;
- loading;
- errores.

En la vista individual:

pacientes = []

En la vista "Todos los pacientes":

pacientes contiene el resumen agregado
de cada paciente.
====================================
*/

const initialState = {

    cargando:
        false,

    error:
        null,

    periodo:
        null,

    asistencia:
    null,

    asistencia_padres:
        null,

    economia: {

        cuenta:
            null,

        resumen:
            null,

        cargos:
            []

    },

    pacientes:
        [],

    turnos:
        []

};


/*
====================================
REDUCER ESTADÍSTICAS
====================================
*/

export default function estadisticasPacienteReducer(
    state = initialState,
    action
) {

    switch (action.type) {


        /*
        ====================================
        CARGANDO ESTADÍSTICAS
        ====================================
        */

        case CARGAR_ESTADISTICAS_PACIENTE:

            return {

                ...state,

                cargando:
                    true,

                error:
                    null

            };


        /*
        ====================================
        ESTADÍSTICAS CARGADAS
        ====================================
        */

        case CARGAR_ESTADISTICAS_PACIENTE_EXITO:

            return {

                ...state,

                cargando:
                    false,

                error:
                    null,


                /*
                ====================================
                PERÍODO
                ====================================
                */

                periodo:
                    action.payload?.periodo ||
                    null,


                /*
                ====================================
                ASISTENCIA PACIENTE
                ====================================
                */

                asistencia:
                    action.payload?.asistencia ||
                    null,


                /*
                ====================================
                ASISTENCIA PADRES
                ====================================

                Solo viene informada en la vista
                individual del paciente.

                En la vista global puede venir null
                hasta que implementemos el resumen
                agrupado de padres.
                ====================================
                */

                asistencia_padres:
                    action.payload?.asistencia_padres ||
                    null,


                /*
                ====================================
                ECONOMÍA
                ====================================
                */

                economia: {

                    cuenta:
                        action.payload
                            ?.economia
                            ?.cuenta ||
                        null,

                    resumen:
                        action.payload
                            ?.economia
                            ?.resumen ||
                        null,

                    cargos:
                        Array.isArray(
                            action.payload
                                ?.economia
                                ?.cargos
                        )
                            ? action.payload
                                .economia
                                .cargos
                            : []

                },


                /*
                ====================================
                RESUMEN POR PACIENTE
                ====================================

                Solo viene informado en la vista
                "Todos los pacientes".

                En una consulta individual queda
                como array vacío.
                ====================================
                */

                pacientes:
                    Array.isArray(
                        action.payload?.pacientes
                    )
                        ? action.payload.pacientes
                        : [],


                /*
                ====================================
                TURNOS
                ====================================

                Vista individual:
                contiene el detalle de sesiones.

                Vista global:
                actualmente viene vacío porque
                usamos resumen por paciente.
                ====================================
                */

                turnos:
                    Array.isArray(
                        action.payload?.turnos
                    )
                        ? action.payload.turnos
                        : []

            };


        /*
        ====================================
        ERROR AL CARGAR
        ====================================
        */

        case CARGAR_ESTADISTICAS_PACIENTE_ERROR:

            return {

                ...state,

                cargando:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudieron cargar las estadísticas.'
                    }

            };


        /*
        ====================================
        CERRAR SESIÓN
        ====================================
        */

        case CERRAR_SESION:

            return initialState;


        /*
        ====================================
        DEFAULT
        ====================================
        */

        default:

            return state;

    }

}